<template>
    <div>
        <div id="contain-all" v-show="showHTML">
            <h3 id="chamada" v-html="chamada"></h3>
            <div id="img1-container" v-resize-image>
                <img @load="incrementLoad" :src="'https://circular.rxy.com.br/api/public/imgs/' + product_1.code + '_face.png'">
            </div>
            <p id="titulo-1" v-html="product_1.name"></p>
            <p id="carac-1" v-html="product_1.feature"></p>
            <div id="container-price-1" v-show="this.theme === 'vqt'">
                <p id="values-1">
                    à vista: {{ product_1.sight_price }}
                </p>
                <div style="width: 100%; height: 70px">
                    <div style="width: 25%; float: left;">
                        <p id="parcelas-1">{{ product_1.payment_x }}x</p>
                        <p id="prefix-1">R$</p>	
                    </div>
                    <div style="width: 75%; float: left;">
                        <p id="price-parcela-1">
                            {{ product_1.payment_price }},<small>{{ product_1.payment_price_cents }}</small>
                        </p>
                    </div>
                </div>
                <p id="preco-prazo-1">
                    Total a prazo {{ product_1.forward_price }}
                </p>
            </div>

            <div id="container-price-theme-23-1" v-show="this.theme != 'vqt'">
                <div style="width: 30%; float: left; line-height: 0;">
                    <p style="font-size: 20px">{{ product_1.payment_x }}x</p>
                    <p style="font-size: 28px; color: #2c46f6; font-family: Segoe UI Bold;">R$</p>
                </div>
                <div style="width: 70%; float: left; padding-top: 5px">
                    <p class="reset" style="font-family: Segoe UI Bold; font-size: 96px; font-weight: bold; color: #2c46f6; line-height: 0.6">{{ product_1.payment_price }}<span style="font-family: Segoe UI Bold;font-size: 38px; font-weight: bold; position: absolute; top: 0; transform: translateY(50%)">,{{ product_1.payment_price_cents }}</span></p>
                </div>
                <p class="reset" style="font-size: 16px; float: left; width: 100%" v-html="product_1.options_buy"></p>
                <p class="reset" style="font-family: Segoe UI Bold; font-size: 22px; font-wight: bold; color: #2c46f6; float: left; width: 100%">À VISTA {{ product_1.sight_price }}</p>
                <p class="reset" style="font-size: 16px; float: left; width: 100%">Total a prazo {{ product_1.forward_price }}</p>
            </div>
            


            <div id="img2-container" v-bind:class="{ img_2_tema_23: (this.theme != 'dga' && this.theme != 'ang') }" v-resize-image>
                <img @load="incrementLoad" :src="'https://circular.rxy.com.br/api/public/imgs/' + product_2.code + '_face.png'">
            </div>
            <p id="titulo-2" v-html="product_2.name"></p>
            <p id="carac-2" v-html="product_2.feature"></p>
            <div id="container-price-2" v-show="this.theme === 'vqt'">
                <p id="values-2">
                    à vista: {{ product_2.sight_price }}
                </p>
                <div style="width: 100%; height: 70px">
                    <div style="width: 25%; float: left;">
                        <p id="parcelas-2">{{ product_2.payment_x }}x</p>
                        <p id="prefix-2">R$</p>	
                    </div>
                    <div style="width: 75%; float: left;">
                        <p id="price-parcela-2">
                            {{ product_2.payment_price }},<small>{{ product_2.payment_price_cents }}</small>
                        </p>
                    </div>
                </div>
                <p id="preco-prazo-2">
                    Total a prazo {{ product_2.forward_price }}
                </p>
            </div>

            <div id="container-price-theme-23-2" v-show="this.theme != 'vqt'">
                <div style="width: 30%; float: left; line-height: 0;">
                    <p style="font-size: 20px">{{ product_2.payment_x }}x</p>
                    <p style="font-size: 28px; color: #2c46f6; font-family: Segoe UI Bold;">R$</p>
                </div>
                <div style="width: 70%; float: left; padding-top: 5px">
                    <p class="reset" style="font-family: Segoe UI Bold; font-size: 96px; font-weight: bold; color: #2c46f6; line-height: 0.6">{{ product_2.payment_price }}<span style="font-family: Segoe UI Bold;font-size: 38px; font-weight: bold; position: absolute; top: 0; transform: translateY(50%)">,{{ product_2.payment_price_cents }}</span></p>
                </div>
                <p class="reset" style="font-size: 16px; float: left; width: 100%" v-html="product_2.options_buy"></p>
                <p class="reset" style="font-family: Segoe UI Bold; font-size: 22px; font-wight: bold; color: #2c46f6; float: left; width: 100%">À VISTA {{ product_2.sight_price }}</p>
                <p class="reset" style="font-size: 16px; float: left; width: 100%">Total a prazo {{ product_2.forward_price }}</p>
            </div>

            <div id="img3-container" v-bind:class="{ img_3_tema_23: (this.theme != 'dga' && this.theme != 'ang') }" v-resize-image>
                <img @load="incrementLoad" :src="'https://circular.rxy.com.br/api/public/imgs/' + product_3.code + '_face.png'">
            </div>
            <p id="titulo-3" v-html="product_3.name"></p>
            <p id="carac-3" v-html="product_3.feature"></p>
            <div id="container-price-3" v-show="this.theme === 'vqt'">
                <p id="values-3">
                    à vista: {{ product_3.sight_price }}
                </p>
                <div style="width: 100%; height: 70px">
                    <div style="width: 25%; float: left;">
                        <p id="parcelas-3">{{ product_3.payment_x }}x</p>
                        <p id="prefix-3">R$</p>	
                    </div>
                    <div style="width: 75%; float: left;">
                        <p id="price-parcela-3">
                            {{ product_3.payment_price }},<small>{{ product_3.payment_price_cents }}</small>
                        </p>
                    </div>
                </div>
                <p id="preco-prazo-3">
                    Total a prazo {{ product_3.forward_price }}
                </p>
            </div>

            <div id="container-price-theme-23-3" v-show="this.theme != 'vqt'">
                <div style="width: 30%; float: left; line-height: 0;">
                    <p style="font-size: 20px">{{ product_3.payment_x }}x</p>
                    <p style="font-size: 28px; color: #2c46f6; font-family: Segoe UI Bold;">R$</p>
                </div>
                <div style="width: 70%; float: left; padding-top: 5px">
                    <p class="reset" style="font-family: Segoe UI Bold; font-size: 96px; font-weight: bold; color: #2c46f6; line-height: 0.6">{{ product_3.payment_price }}<span style="font-family: Segoe UI Bold;font-size: 38px; font-weight: bold; position: absolute; top: 0; transform: translateY(50%)">,{{ product_3.payment_price_cents }}</span></p>
                </div>
                <p class="reset" style="font-size: 16px; float: left; width: 100%" v-html="product_3.options_buy"></p>
                <p class="reset" style="font-family: Segoe UI Bold; font-size: 22px; font-wight: bold; color: #2c46f6; float: left; width: 100%">À VISTA {{ product_3.sight_price }}</p>
                <p class="reset" style="font-size: 16px; float: left; width: 100%">Total a prazo {{ product_3.forward_price }}</p>
            </div>

            <div id="img4-container" v-resize-image>
                <img @load="incrementLoad" :src="'https://circular.rxy.com.br/api/public/imgs/' + product_4.code + '_face.png'">
            </div>
            <p id="titulo-4" v-html="product_4.name"></p>
            <p id="carac-4" v-html="product_4.feature"></p>
            <div id="container-price-4" v-show="this.theme === 'vqt'">
                <p id="values-4">
                    à vista: {{ product_4.sight_price }}
                </p>
                <div style="width: 100%; height: 70px">
                    <div style="width: 25%; float: left;">
                        <p id="parcelas-4">{{ product_4.payment_x }}x</p>
                        <p id="prefix-4">R$</p>	
                    </div>
                    <div style="width: 75%; float: left;">
                        <p id="price-parcela-4">
                            {{ product_4.payment_price }},<small>{{ product_4.payment_price_cents }}</small>
                        </p>
                    </div>
                </div>
                <p id="preco-prazo-4">
                    Total a prazo {{ product_4.forward_price }}
                </p>
            </div>

            <div id="container-price-theme-23-4" v-show="this.theme != 'vqt'">
                <div style="width: 30%; float: left; line-height: 0;">
                    <p style="font-size: 20px">{{ product_4.payment_x }}x</p>
                    <p style="font-size: 28px; color: #2c46f6; font-family: Segoe UI Bold;">R$</p>
                </div>
                <div style="width: 70%; float: left; padding-top: 5px">
                    <p class="reset" style="font-family: Segoe UI Bold; font-size: 96px; font-weight: bold; color: #2c46f6; line-height: 0.6">{{ product_4.payment_price }}<span style="font-family: Segoe UI Bold;font-size: 38px; font-weight: bold; position: absolute; top: 0; transform: translateY(50%)">,{{ product_4.payment_price_cents }}</span></p>
                </div>
                <p class="reset" style="font-size: 16px; float: left; width: 100%" v-html="product_4.options_buy"></p>
                <p class="reset" style="font-family: Segoe UI Bold; font-size: 22px; font-wight: bold; color: #2c46f6; float: left; width: 100%">À VISTA {{ product_4.sight_price }}</p>
                <p class="reset" style="font-size: 16px; float: left; width: 100%">Total a prazo {{ product_4.forward_price }}</p>
            </div>

            <div id="img5-container" v-resize-image>
                <img @load="incrementLoad" :src="'https://circular.rxy.com.br/api/public/imgs/' + product_5.code + '_face.png'">
            </div>
            <p id="titulo-5" v-html="product_5.name"></p>
            <p id="carac-5" v-html="product_5.feature"></p>
            <div id="container-price-5" v-show="this.theme === 'vqt'">
                <p id="values-5">
                    à vista: {{ product_5.sight_price }}
                </p>
                <div style="width: 100%; height: 70px">
                    <div style="width: 25%; float: left;">
                        <p id="parcelas-5">{{ product_5.payment_x }}x</p>
                        <p id="prefix-5">R$</p>	
                    </div>
                    <div style="width: 75%; float: left;">
                        <p id="price-parcela-5">
                            {{ product_5.payment_price }},<small>{{ product_5.payment_price_cents }}</small>
                        </p>
                    </div>
                </div>
                <p id="preco-prazo-5">
                    Total a prazo {{ product_5.forward_price }}
                </p>
            </div>

            <div id="container-price-theme-23-5" v-show="this.theme != 'vqt'">
                <div style="width: 30%; float: left; line-height: 0;">
                    <p style="font-size: 20px">{{ product_5.payment_x }}x</p>
                    <p style="font-size: 28px; color: #2c46f6; font-family: Segoe UI Bold;">R$</p>
                </div>
                <div style="width: 70%; float: left; padding-top: 5px">
                    <p class="reset" style="font-family: Segoe UI Bold; font-size: 96px; font-weight: bold; color: #2c46f6; line-height: 0.6">{{ product_5.payment_price }}<span style="font-family: Segoe UI Bold;font-size: 38px; font-weight: bold; position: absolute; top: 0; transform: translateY(50%)">,{{ product_5.payment_price_cents }}</span></p>
                </div>
                <p class="reset" style="font-size: 16px; float: left; width: 100%" v-html="product_5.options_buy"></p>
                <p class="reset" style="font-family: Segoe UI Bold; font-size: 22px; font-wight: bold; color: #2c46f6; float: left; width: 100%">À VISTA {{ product_5.sight_price }}</p>
                <p class="reset" style="font-size: 16px; float: left; width: 100%">Total a prazo {{ product_5.forward_price }}</p>
            </div>

            <div id="img6-container" v-resize-image>
                <img @load="incrementLoad" :src="'https://circular.rxy.com.br/api/public/imgs/' + product_6.code + '_face.png'">
            </div>
            <p id="titulo-6" v-html="product_6.name"></p>
            <p id="carac-6" v-html="product_6.feature"></p>
            <div id="container-price-6" v-show="this.theme === 'vqt'">
                <p id="values-6">
                    à vista: {{ product_6.sight_price }}
                </p>
                <div style="width: 100%; height: 70px">
                    <div style="width: 25%; float: left;">
                        <p id="parcelas-6">{{ product_6.payment_x }}x</p>
                        <p id="prefix-6">R$</p>	
                    </div>
                    <div style="width: 75%; float: left;">
                        <p id="price-parcela-6">
                            {{ product_6.payment_price }},<small>{{ product_6.payment_price_cents }}</small>
                        </p>
                    </div>
                </div>
                <p id="preco-prazo-6">
                    Total a prazo {{ product_6.forward_price }}
                </p>
            </div>

            <div id="container-price-theme-23-6" v-show="this.theme != 'vqt'">
                <div style="width: 30%; float: left; line-height: 0;">
                    <p style="font-size: 20px">{{ product_6.payment_x }}x</p>
                    <p style="font-size: 28px; color: #2c46f6; font-family: Segoe UI Bold;">R$</p>
                </div>
                <div style="width: 70%; float: left; padding-top: 5px">
                    <p class="reset" style="font-family: Segoe UI Bold; font-size: 96px; font-weight: bold; color: #2c46f6; line-height: 0.6">{{ product_6.payment_price }}<span style="font-family: Segoe UI Bold;font-size: 38px; font-weight: bold; position: absolute; top: 0; transform: translateY(50%)">,{{ product_6.payment_price_cents }}</span></p>
                </div>
                <p class="reset" style="font-size: 16px; float: left; width: 100%" v-html="product_6.options_buy"></p>
                <p class="reset" style="font-family: Segoe UI Bold; font-size: 22px; font-wight: bold; color: #2c46f6; float: left; width: 100%">À VISTA {{ product_6.sight_price }}</p>
                <p class="reset" style="font-size: 16px; float: left; width: 100%">Total a prazo {{ product_6.forward_price }}</p>
            </div>

            <div id="img7-container" v-resize-image>
                <img @load="incrementLoad" :src="'https://circular.rxy.com.br/api/public/imgs/' + product_7.code + '_face.png'">
            </div>
            <p id="titulo-7" v-html="product_7.name"></p>
            <p id="carac-7" v-html="product_7.feature"></p>
            <div id="container-price-7" v-show="this.theme === 'vqt'">
                <p id="values-7">
                    à vista: {{ product_7.sight_price }}
                </p>
                <div style="width: 100%; height: 70px">
                    <div style="width: 25%; float: left;">
                        <p id="parcelas-7">{{ product_7.payment_x }}x</p>
                        <p id="prefix-7">R$</p>	
                    </div>
                    <div style="width: 75%; float: left;">
                        <p id="price-parcela-7">
                            {{ product_7.payment_price }},<small>{{ product_7.payment_price_cents }}</small>
                        </p>
                    </div>
                </div>
                <p id="preco-prazo-7">
                    Total a prazo {{ product_7.forward_price }}
                </p>
            </div>

            <div id="container-price-theme-23-7" v-show="this.theme != 'vqt'">
                <div style="width: 30%; float: left; line-height: 0;">
                    <p style="font-size: 20px">{{ product_7.payment_x }}x</p>
                    <p style="font-size: 28px; color: #2c46f6; font-family: Segoe UI Bold;">R$</p>
                </div>
                <div style="width: 70%; float: left; padding-top: 5px">
                    <p class="reset" style="font-family: Segoe UI Bold; font-size: 96px; font-weight: bold; color: #2c46f6; line-height: 0.6">{{ product_7.payment_price }}<span style="font-family: Segoe UI Bold;font-size: 38px; font-weight: bold; position: absolute; top: 0; transform: translateY(50%)">,{{ product_7.payment_price_cents }}</span></p>
                </div>
                <p class="reset" style="font-size: 16px; float: left; width: 100%" v-html="product_7.options_buy"></p>
                <p class="reset" style="font-family: Segoe UI Bold; font-size: 22px; font-wight: bold; color: #2c46f6; float: left; width: 100%">À VISTA {{ product_7.sight_price }}</p>
                <p class="reset" style="font-size: 16px; float: left; width: 100%">Total a prazo {{ product_7.forward_price }}</p>
            </div>

            <div id="img8-container" v-resize-image>
                <img @load="incrementLoad" :src="'https://circular.rxy.com.br/api/public/imgs/' + product_8.code + '_face.png'">
            </div>
            <p id="titulo-8" v-html="product_8.name"></p>
            <p id="carac-8" v-html="product_8.feature"></p>
            <div id="container-price-8" v-show="this.theme === 'vqt'">
                <p id="values-8">
                    à vista: {{ product_8.sight_price }}
                </p>
                <div style="width: 100%; height: 70px">
                    <div style="width: 25%; float: left;">
                        <p id="parcelas-8">{{ product_8.payment_x }}x</p>
                        <p id="prefix-8">R$</p>	
                    </div>
                    <div style="width: 75%; float: left;">
                        <p id="price-parcela-8">
                            {{ product_8.payment_price }},<small>{{ product_8.payment_price_cents }}</small>
                        </p>
                    </div>
                </div>
                <p id="preco-prazo-8">
                    Total a prazo {{ product_8.forward_price }}
                </p>
            </div>

            <div id="container-price-theme-23-8" v-show="this.theme != 'vqt'">
                <div style="width: 30%; float: left; line-height: 0;">
                    <p style="font-size: 20px">{{ product_8.payment_x }}x</p>
                    <p style="font-size: 28px; color: #2c46f6; font-family: Segoe UI Bold;">R$</p>
                </div>
                <div style="width: 70%; float: left; padding-top: 5px">
                    <p class="reset" style="font-family: Segoe UI Bold; font-size: 96px; font-weight: bold; color: #2c46f6; line-height: 0.6">{{ product_8.payment_price }}<span style="font-family: Segoe UI Bold;font-size: 38px; font-weight: bold; position: absolute; top: 0; transform: translateY(50%)">,{{ product_8.payment_price_cents }}</span></p>
                </div>
                <p class="reset" style="font-size: 16px; float: left; width: 100%" v-html="product_8.options_buy"></p>
                <p class="reset" style="font-family: Segoe UI Bold; font-size: 22px; font-wight: bold; color: #2c46f6; float: left; width: 100%">À VISTA {{ product_8.sight_price }}</p>
                <p class="reset" style="font-size: 16px; float: left; width: 100%">Total a prazo {{ product_8.forward_price }}</p>
            </div>

            <div id="img9-container" v-resize-image>
                <img @load="incrementLoad" :src="'https://circular.rxy.com.br/api/public/imgs/' + product_9.code + '_face.png'">
            </div>
            <p id="titulo-9" v-html="product_9.name"></p>
            <p id="carac-9" v-html="product_9.feature"></p>
            <div id="container-price-9" v-show="this.theme === 'vqt'">
                <p id="values-9">
                    à vista: {{ product_9.sight_price }}
                </p>
                <div style="width: 100%; height: 70px">
                    <div style="width: 25%; float: left;">
                        <p id="parcelas-9">{{ product_9.payment_x }}x</p>
                        <p id="prefix-9">R$</p>	
                    </div>
                    <div style="width: 75%; float: left;">
                        <p id="price-parcela-9">
                            {{ product_9.payment_price }},<small>{{ product_9.payment_price_cents }}</small>
                        </p>
                    </div>
                </div>
                <p id="preco-prazo-9">
                    Total a prazo {{ product_9.forward_price }}
                </p>
            </div>

            <div id="container-price-theme-23-9" v-show="this.theme != 'vqt'">
                <div style="width: 30%; float: left; line-height: 0;">
                    <p style="font-size: 20px">{{ product_9.payment_x }}x</p>
                    <p style="font-size: 28px; color: #2c46f6; font-family: Segoe UI Bold;">R$</p>
                </div>
                <div style="width: 70%; float: left; padding-top: 5px">
                    <p class="reset" style="font-family: Segoe UI Bold; font-size: 96px; font-weight: bold; color: #2c46f6; line-height: 0.6">{{ product_9.payment_price }}<span style="font-family: Segoe UI Bold;font-size: 38px; font-weight: bold; position: absolute; top: 0; transform: translateY(50%)">,{{ product_9.payment_price_cents }}</span></p>
                </div>
                <p class="reset" style="font-size: 16px; float: left; width: 100%" v-html="product_9.options_buy"></p>
                <p class="reset" style="font-family: Segoe UI Bold; font-size: 22px; font-wight: bold; color: #2c46f6; float: left; width: 100%">À VISTA {{ product_9.sight_price }}</p>
                <p class="reset" style="font-size: 16px; float: left; width: 100%">Total a prazo {{ product_9.forward_price }}</p>
            </div>

            <img @load="incrementLoad" :src="require('../../assets/banners/' + this.banner + '.png')" id="banner" alt="">

            <div id="juridico">
                <p>{{ juridico }}</p>
            </div>
        </div>
        <!-- <img :src="output" v-show="output != null" id="download" crossorigin="anonymous"> -->
        <p v-show="showHTML === false && url === null">Imagem sendo gerada, aguarde...</p>
        <img v-show="url !== null" :src="url" alt="Imagem para Download" height="700px" class="responsive-img">
        <a :href="url" target="_blank" v-show="url !== null" download style="background: #039be5;color: #fff;padding: 10px 10px;border-radius: 5px;">Baixar imagem</a>
        <a href="/" v-show="url !== null" style="background: #EE0000;color: #fff;padding: 10px 10px;border-radius: 5px;">Voltar para tela inicial</a>
    </div>
</template>

<script>
function fold(input, lineSize, lineArray) {
    lineArray = lineArray || [];
    if (input.length <= lineSize) {
        lineArray.push(input);
        return lineArray;
    }
    lineArray.push(input.substring(0, lineSize));
    var tail = input.substring(lineSize);
    return fold(tail, lineSize, lineArray);
}

function sliceWords(str, size) {
	var trimmedString = str.substr(0, size);

    //re-trim if we are in the middle of a word
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))

    return trimmedString;
}

import { BASE_URL_API, SYSTEM_ENV } from "../../config.js";

export default {
    name: "generate2x",
    data() {
        return {
            items: [],
            abrangencia: null,
            chamada: null,
            dtinicio: null,
            dtfim: null,
            juridico: null,
            theme: this.theme,
            banner: null,
            background_color: null,
            url: null,
            showHTML: true,
            allLoaded: 0,
            product_1: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null
            },
            product_2: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_3: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_4: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_5: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_6: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_7: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_8: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_9: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
        }
    },
    created() {
        var body = document.body;
        var className = "body";
        if (body.classList)
            body.classList.add(className);
        else
            body.className += ' ' + className;

        var html = document.querySelector("html");
        var className = "html";
        if (html.classList)
            html.classList.add(className);
        else
            html.className += ' ' + className;

        this.items = this.$route.params.items;
        this.abrangencia = this.$route.params.abrangencia;
        let linha1 = sliceWords(this.$route.params.chamada + " ", 25);
        let chamada_total = this.$route.params.chamada;
        let linha2 = sliceWords(this.$route.params.chamada.replace(linha1, "") + " ", 25);
        this.chamada = linha1 + "<br />" + linha2;
        this.dtinicio = this.$route.params.dtinicio;
        this.dtfim = this.$route.params.dtfim;

        this.theme = this.$route.params.theme;
        this.banner = this.$route.params.banner;
        this.background_color = this.$route.params.background_color;

        document.body.style.backgroundColor = this.background_color;

        var classNameBody = '';
        var classNameChamada = '';
        switch (this.theme) {
            case 'dga':
                classNameBody = 'tema-2';
                classNameChamada = 'chamada-tema-2';
                break;
            case 'ang':
                classNameBody = 'tema-3';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'oug':
                classNameBody = 'tema-4';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'dma':
                classNameBody = 'tema-5';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'mgf':
                classNameBody = 'tema-6';
                classNameChamada = 'chamada-tema-3';
                break;
        }

        if (classNameBody != '') {
            var body = document.body;
            if (body.classList)
                body.classList.add(classNameBody);
            else
                body.className += ' ' + classNameBody;
        }

        if (classNameChamada != '') {
            setTimeout(function() {
                var chamada = document.querySelector("#chamada");
                if (chamada.classList)
                    chamada.classList.add(classNameChamada);
                else
                    chamada.className += ' ' + classNameChamada;
            }, 1000);
        }

        this.juridico = this.mounta_juridico();

        // Produto 1

        // let name1 = fold(this.items[0].name.slice(0, 30), 18).join('<br/>');
        var txtCompleto1 = sliceWords(this.items[0].name + " ", 30);
        
        var firstLine1 = sliceWords(txtCompleto1, 18);
        txtCompleto1 = txtCompleto1.replace(firstLine1 + " ", "");
        var secondLine1 = sliceWords(txtCompleto1 + " ", 18);

        var lines1 = [firstLine1, secondLine1];

        this.product_1.name = lines1.join("<br />");
        this.product_1.sight_price = Number(this.items[0].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        this.product_1.forward_price = Number(this.items[0].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        let payment_price1 = String(this.items[0].payment_price).split(".");
        this.product_1.payment_price = Number(payment_price1[0]);
        this.product_1.payment_price_cents = Number(payment_price1[1]);
        if (String(this.product_1.payment_price_cents).length < 2) {
            this.product_1.payment_price_cents = this.pad_with_zeroes(this.product_1.payment_price_cents, 2);
        }
        if (isNaN(this.product_1.payment_price_cents)) {
            this.product_1.payment_price_cents = '00';
        }
        this.product_1.payment_x = this.items[0].payment_x;
        this.product_1.code = this.items[0].code;
        this.product_1.feature = this.items[0].features;

        this.product_1.without_entrance = this.items[0].without_entrance;
        this.product_1.without_interest = this.items[0].without_interest;
        this.product_1.in_carne = this.items[0].in_carne;
        this.product_1.in_card = this.items[0].in_card;

        this.product_1.options_buy = '';
        if (this.product_1.without_entrance && this.product_1.without_interest) {
            this.product_1.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_1.without_entrance)
                this.product_1.options_buy = "Sem Entrada";
            else if (this.product_1.without_interest)
                this.product_1.options_buy = "Sem Juros";
        }

        if (this.product_1.without_entrance || this.product_1.without_interest) {
            if (this.product_1.in_carne || this.product_1.in_card)
                this.product_1.options_buy += " | ";
        }

        if (this.product_1.in_carne && this.product_1.in_card) {
            this.product_1.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_1.in_carne)
                this.product_1.options_buy += "Carnê";
            else if (this.product_1.in_card)
                this.product_1.options_buy += "Cartão";
        }

        this.product_1.options_buy = this.product_1.options_buy.split("|");
        if (this.product_1.options_buy.length > 1) {
            this.product_1.options_buy = this.product_1.options_buy.join("<br>");
        } else {
            this.product_1.options_buy = this.product_1.options_buy[0];
        }

        // Produto 2

        // let name2 = fold(this.items[1].name.slice(0, 30), 18).join('<br/>');

        var txtCompleto2 = sliceWords(this.items[1].name + " ", 30);
        // console.log('txt', txtCompleto2);
        var firstLine2 = sliceWords(txtCompleto2, 18);
        // console.log('txt', firstLine2);
        txtCompleto2 = txtCompleto2.replace(firstLine2 + " ", "");
        // console.log('txt', txtCompleto2);
        var secondLine2 = sliceWords(txtCompleto2 + " ", 18);

        var lines2 = [firstLine2, secondLine2];

        this.product_2.name = lines2.join("<br />");
        this.product_2.sight_price = Number(this.items[1].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        this.product_2.forward_price = Number(this.items[1].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        let payment_price2 = String(this.items[1].payment_price).split(".");
        this.product_2.payment_price = Number(payment_price2[0]);
        this.product_2.payment_price_cents = Number(payment_price2[1]);
        if (String(this.product_2.payment_price_cents).length < 2) {
            this.product_2.payment_price_cents = this.pad_with_zeroes(this.product_2.payment_price_cents, 2);
        }
        if (isNaN(this.product_2.payment_price_cents)) {
            this.product_2.payment_price_cents = '00';
        }
        this.product_2.payment_x = this.items[1].payment_x;
        this.product_2.code = this.items[1].code;
        this.product_2.feature = this.items[1].features;

        this.product_2.without_entrance = this.items[1].without_entrance;
        this.product_2.without_interest = this.items[1].without_interest;
        this.product_2.in_carne = this.items[1].in_carne;
        this.product_2.in_card = this.items[1].in_card;

        this.product_2.options_buy = '';
        if (this.product_2.without_entrance && this.product_2.without_interest) {
            this.product_2.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_2.without_entrance)
                this.product_2.options_buy = "Sem Entrada";
            else if (this.product_2.without_interest)
                this.product_2.options_buy = "Sem Juros";
        }

        if (this.product_2.without_entrance || this.product_2.without_interest) {
            if (this.product_2.in_carne || this.product_2.in_card)
                this.product_2.options_buy += " | ";
        }

        if (this.product_2.in_carne && this.product_2.in_card) {
            this.product_2.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_2.in_carne)
                this.product_2.options_buy += "Carnê";
            else if (this.product_2.in_card)
                this.product_2.options_buy += "Cartão";
        }

        this.product_2.options_buy = this.product_2.options_buy.split("|");
        if (this.product_2.options_buy.length > 1) {
            this.product_2.options_buy = this.product_2.options_buy.join("<br>");
        } else {
            this.product_2.options_buy = this.product_2.options_buy[0];
        }

        // Produto 3

        var txtCompleto3 = sliceWords(this.items[2].name + " ", 30);
        
        var firstLine3 = sliceWords(txtCompleto3, 18);
        txtCompleto3 = txtCompleto3.replace(firstLine3 + " ", "");
        var secondLine3 = sliceWords(txtCompleto3 + " ", 18);

        var lines3 = [firstLine3, secondLine3];

        this.product_3.name = lines3.join("<br />");
        this.product_3.sight_price = Number(this.items[2].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        this.product_3.forward_price = Number(this.items[2].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        let payment_price3 = String(this.items[2].payment_price).split(".");
        this.product_3.payment_price = Number(payment_price3[0]);
        this.product_3.payment_price_cents = Number(payment_price3[1]);
        if (String(this.product_3.payment_price_cents).length < 2) {
            this.product_3.payment_price_cents = this.pad_with_zeroes(this.product_3.payment_price_cents, 2);
        }
        if (isNaN(this.product_3.payment_price_cents)) {
            this.product_3.payment_price_cents = '00';
        }
        this.product_3.payment_x = this.items[2].payment_x;
        this.product_3.code = this.items[2].code;
        this.product_3.feature = this.items[2].features;

        this.product_3.without_entrance = this.items[2].without_entrance;
        this.product_3.without_interest = this.items[2].without_interest;
        this.product_3.in_carne = this.items[2].in_carne;
        this.product_3.in_card = this.items[2].in_card;

        this.product_3.options_buy = '';
        if (this.product_3.without_entrance && this.product_3.without_interest) {
            this.product_3.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_3.without_entrance)
                this.product_3.options_buy = "Sem Entrada";
            else if (this.product_3.without_interest)
                this.product_3.options_buy = "Sem Juros";
        }

        if (this.product_3.without_entrance || this.product_3.without_interest) {
            if (this.product_3.in_carne || this.product_3.in_card)
                this.product_3.options_buy += " | ";
        }

        if (this.product_3.in_carne && this.product_3.in_card) {
            this.product_3.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_3.in_carne)
                this.product_3.options_buy += "Carnê";
            else if (this.product_3.in_card)
                this.product_3.options_buy += "Cartão";
        }

        this.product_3.options_buy = this.product_3.options_buy.split("|");
        if (this.product_3.options_buy.length > 1) {
            this.product_3.options_buy = this.product_3.options_buy.join("<br>");
        } else {
            this.product_3.options_buy = this.product_3.options_buy[0];
        }

        // Produto 4

        var txtCompleto4 = sliceWords(this.items[3].name + " ", 30);
        
        var firstLine4 = sliceWords(txtCompleto4, 18);
        txtCompleto4 = txtCompleto4.replace(firstLine4 + " ", "");
        var secondLine4 = sliceWords(txtCompleto4 + " ", 18);

        var lines4 = [firstLine4, secondLine4];

        this.product_4.name = lines4.join("<br />");
        this.product_4.sight_price = Number(this.items[3].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        this.product_4.forward_price = Number(this.items[3].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        let payment_price4 = String(this.items[3].payment_price).split(".");
        this.product_4.payment_price = Number(payment_price4[0]);
        this.product_4.payment_price_cents = Number(payment_price4[1]);
        if (String(this.product_4.payment_price_cents).length < 2) {
            this.product_4.payment_price_cents = this.pad_with_zeroes(this.product_4.payment_price_cents, 2);
        }
        if (isNaN(this.product_4.payment_price_cents)) {
            this.product_4.payment_price_cents = '00';
        }
        this.product_4.payment_x = this.items[3].payment_x;
        this.product_4.code = this.items[3].code;
        this.product_4.feature = this.items[3].features;

        this.product_4.without_entrance = this.items[3].without_entrance;
        this.product_4.without_interest = this.items[3].without_interest;
        this.product_4.in_carne = this.items[3].in_carne;
        this.product_4.in_card = this.items[3].in_card;

        this.product_4.options_buy = '';
        if (this.product_4.without_entrance && this.product_4.without_interest) {
            this.product_4.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_4.without_entrance)
                this.product_4.options_buy = "Sem Entrada";
            else if (this.product_4.without_interest)
                this.product_4.options_buy = "Sem Juros";
        }

        if (this.product_4.without_entrance || this.product_4.without_interest) {
            if (this.product_4.in_carne || this.product_4.in_card)
                this.product_4.options_buy += " | ";
        }

        if (this.product_4.in_carne && this.product_4.in_card) {
            this.product_4.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_4.in_carne)
                this.product_4.options_buy += "Carnê";
            else if (this.product_4.in_card)
                this.product_4.options_buy += "Cartão";
        }

        this.product_4.options_buy = this.product_4.options_buy.split("|");
        if (this.product_4.options_buy.length > 1) {
            this.product_4.options_buy = this.product_4.options_buy.join("<br>");
        } else {
            this.product_4.options_buy = this.product_4.options_buy[0];
        }

        // Produto 5

        var txtCompleto5 = sliceWords(this.items[4].name + " ", 30);
        
        var firstLine5 = sliceWords(txtCompleto5, 18);
        txtCompleto5 = txtCompleto5.replace(firstLine5 + " ", "");
        var secondLine5 = sliceWords(txtCompleto5 + " ", 18);

        var lines5 = [firstLine5, secondLine5];

        this.product_5.name = lines5.join("<br />");
        this.product_5.sight_price = Number(this.items[4].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        this.product_5.forward_price = Number(this.items[4].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        let payment_price5 = String(this.items[4].payment_price).split(".");
        this.product_5.payment_price = Number(payment_price5[0]);
        this.product_5.payment_price_cents = Number(payment_price5[1]);
        if (String(this.product_5.payment_price_cents).length < 2) {
            this.product_5.payment_price_cents = this.pad_with_zeroes(this.product_5.payment_price_cents, 2);
        }
        if (isNaN(this.product_5.payment_price_cents)) {
            this.product_5.payment_price_cents = '00';
        }
        this.product_5.payment_x = this.items[4].payment_x;
        this.product_5.code = this.items[4].code;
        this.product_5.feature = this.items[4].features;

        this.product_5.without_entrance = this.items[4].without_entrance;
        this.product_5.without_interest = this.items[4].without_interest;
        this.product_5.in_carne = this.items[4].in_carne;
        this.product_5.in_card = this.items[4].in_card;

        this.product_5.options_buy = '';
        if (this.product_5.without_entrance && this.product_5.without_interest) {
            this.product_5.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_5.without_entrance)
                this.product_5.options_buy = "Sem Entrada";
            else if (this.product_5.without_interest)
                this.product_5.options_buy = "Sem Juros";
        }

        if (this.product_5.without_entrance || this.product_5.without_interest) {
            if (this.product_5.in_carne || this.product_5.in_card)
                this.product_5.options_buy += " | ";
        }

        if (this.product_5.in_carne && this.product_5.in_card) {
            this.product_5.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_5.in_carne)
                this.product_5.options_buy += "Carnê";
            else if (this.product_5.in_card)
                this.product_5.options_buy += "Cartão";
        }

        this.product_5.options_buy = this.product_5.options_buy.split("|");
        if (this.product_5.options_buy.length > 1) {
            this.product_5.options_buy = this.product_5.options_buy.join("<br>");
        } else {
            this.product_5.options_buy = this.product_5.options_buy[0];
        }

        // Produto 6

        var txtCompleto6 = sliceWords(this.items[5].name + " ", 30);
        
        var firstLine6 = sliceWords(txtCompleto6, 18);
        txtCompleto6 = txtCompleto6.replace(firstLine6 + " ", "");
        var secondLine6 = sliceWords(txtCompleto6 + " ", 18);

        var lines6 = [firstLine6, secondLine6];

        this.product_6.name = lines6.join("<br />");
        this.product_6.sight_price = Number(this.items[5].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        this.product_6.forward_price = Number(this.items[5].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        let payment_price6 = String(this.items[5].payment_price).split(".");
        this.product_6.payment_price = Number(payment_price6[0]);
        this.product_6.payment_price_cents = Number(payment_price6[1]);
        if (String(this.product_6.payment_price_cents).length < 2) {
            this.product_6.payment_price_cents = this.pad_with_zeroes(this.product_6.payment_price_cents, 2);
        }
        if (isNaN(this.product_6.payment_price_cents)) {
            this.product_6.payment_price_cents = '00';
        }
        this.product_6.payment_x = this.items[5].payment_x;
        this.product_6.code = this.items[5].code;
        this.product_6.feature = this.items[5].features;

        this.product_6.without_entrance = this.items[5].without_entrance;
        this.product_6.without_interest = this.items[5].without_interest;
        this.product_6.in_carne = this.items[5].in_carne;
        this.product_6.in_card = this.items[5].in_card;

        this.product_6.options_buy = '';
        if (this.product_6.without_entrance && this.product_6.without_interest) {
            this.product_6.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_6.without_entrance)
                this.product_6.options_buy = "Sem Entrada";
            else if (this.product_6.without_interest)
                this.product_6.options_buy = "Sem Juros";
        }

        if (this.product_6.without_entrance || this.product_6.without_interest) {
            if (this.product_6.in_carne || this.product_6.in_card)
                this.product_6.options_buy += " | ";
        }

        if (this.product_6.in_carne && this.product_6.in_card) {
            this.product_6.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_6.in_carne)
                this.product_6.options_buy += "Carnê";
            else if (this.product_6.in_card)
                this.product_6.options_buy += "Cartão";
        }

        this.product_6.options_buy = this.product_6.options_buy.split("|");
        if (this.product_6.options_buy.length > 1) {
            this.product_6.options_buy = this.product_6.options_buy.join("<br>");
        } else {
            this.product_6.options_buy = this.product_6.options_buy[0];
        }

        // Produto 7

        var txtCompleto7 = sliceWords(this.items[6].name + " ", 30);
        
        var firstLine7 = sliceWords(txtCompleto7, 18);
        txtCompleto7 = txtCompleto7.replace(firstLine7 + " ", "");
        var secondLine7 = sliceWords(txtCompleto7 + " ", 18);

        var lines7 = [firstLine7, secondLine7];

        this.product_7.name = lines7.join("<br />");
        this.product_7.sight_price = Number(this.items[6].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        this.product_7.forward_price = Number(this.items[6].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        let payment_price7 = String(this.items[6].payment_price).split(".");
        this.product_7.payment_price = Number(payment_price7[0]);
        this.product_7.payment_price_cents = Number(payment_price7[1]);
        if (String(this.product_7.payment_price_cents).length < 2) {
            this.product_7.payment_price_cents = this.pad_with_zeroes(this.product_7.payment_price_cents, 2);
        }
        if (isNaN(this.product_7.payment_price_cents)) {
            this.product_7.payment_price_cents = '00';
        }
        this.product_7.payment_x = this.items[6].payment_x;
        this.product_7.code = this.items[6].code;
        this.product_7.feature = this.items[6].features;

        this.product_7.without_entrance = this.items[6].without_entrance;
        this.product_7.without_interest = this.items[6].without_interest;
        this.product_7.in_carne = this.items[6].in_carne;
        this.product_7.in_card = this.items[6].in_card;

        this.product_7.options_buy = '';
        if (this.product_7.without_entrance && this.product_7.without_interest) {
            this.product_7.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_7.without_entrance)
                this.product_7.options_buy = "Sem Entrada";
            else if (this.product_7.without_interest)
                this.product_7.options_buy = "Sem Juros";
        }

        if (this.product_7.without_entrance || this.product_7.without_interest) {
            if (this.product_7.in_carne || this.product_7.in_card)
                this.product_7.options_buy += " | ";
        }

        if (this.product_7.in_carne && this.product_7.in_card) {
            this.product_7.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_7.in_carne)
                this.product_7.options_buy += "Carnê";
            else if (this.product_7.in_card)
                this.product_7.options_buy += "Cartão";
        }

        this.product_7.options_buy = this.product_7.options_buy.split("|");
        if (this.product_7.options_buy.length > 1) {
            this.product_7.options_buy = this.product_7.options_buy.join("<br>");
        } else {
            this.product_7.options_buy = this.product_7.options_buy[0];
        }

        // Produto 8

        var txtCompleto8 = sliceWords(this.items[7].name + " ", 30);
        
        var firstLine8 = sliceWords(txtCompleto8, 18);
        txtCompleto8 = txtCompleto8.replace(firstLine8 + " ", "");
        var secondLine8 = sliceWords(txtCompleto8 + " ", 18);

        var lines8 = [firstLine8, secondLine8];

        this.product_8.name = lines8.join("<br />");
        this.product_8.sight_price = Number(this.items[7].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        this.product_8.forward_price = Number(this.items[7].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        let payment_price8 = String(this.items[7].payment_price).split(".");
        this.product_8.payment_price = Number(payment_price8[0]);
        this.product_8.payment_price_cents = Number(payment_price8[1]);
        if (String(this.product_8.payment_price_cents).length < 2) {
            this.product_8.payment_price_cents = this.pad_with_zeroes(this.product_8.payment_price_cents, 2);
        }
        if (isNaN(this.product_8.payment_price_cents)) {
            this.product_8.payment_price_cents = '00';
        }
        this.product_8.payment_x = this.items[7].payment_x;
        this.product_8.code = this.items[7].code;
        this.product_8.feature = this.items[7].features;

        this.product_8.without_entrance = this.items[7].without_entrance;
        this.product_8.without_interest = this.items[7].without_interest;
        this.product_8.in_carne = this.items[7].in_carne;
        this.product_8.in_card = this.items[7].in_card;

        this.product_8.options_buy = '';
        if (this.product_8.without_entrance && this.product_8.without_interest) {
            this.product_8.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_8.without_entrance)
                this.product_8.options_buy = "Sem Entrada";
            else if (this.product_8.without_interest)
                this.product_8.options_buy = "Sem Juros";
        }

        if (this.product_8.without_entrance || this.product_8.without_interest) {
            if (this.product_8.in_carne || this.product_8.in_card)
                this.product_8.options_buy += " | ";
        }

        if (this.product_8.in_carne && this.product_8.in_card) {
            this.product_8.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_8.in_carne)
                this.product_8.options_buy += "Carnê";
            else if (this.product_8.in_card)
                this.product_8.options_buy += "Cartão";
        }

        this.product_8.options_buy = this.product_8.options_buy.split("|");
        if (this.product_8.options_buy.length > 1) {
            this.product_8.options_buy = this.product_8.options_buy.join("<br>");
        } else {
            this.product_8.options_buy = this.product_8.options_buy[0];
        }

        // Produto 9

        var txtCompleto9 = sliceWords(this.items[8].name + " ", 30);
        
        var firstLine9 = sliceWords(txtCompleto9, 18);
        txtCompleto9 = txtCompleto9.replace(firstLine9 + " ", "");
        var secondLine9 = sliceWords(txtCompleto9 + " ", 18);

        var lines9 = [firstLine9, secondLine9];

        this.product_9.name = lines9.join("<br />");
        this.product_9.sight_price = Number(this.items[8].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        this.product_9.forward_price = Number(this.items[8].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        let payment_price9 = String(this.items[8].payment_price).split(".");
        this.product_9.payment_price = Number(payment_price9[0]);
        this.product_9.payment_price_cents = Number(payment_price9[1]);
        if (String(this.product_9.payment_price_cents).length < 2) {
            this.product_9.payment_price_cents = this.pad_with_zeroes(this.product_9.payment_price_cents, 2);
        }
        if (isNaN(this.product_9.payment_price_cents)) {
            this.product_9.payment_price_cents = '00';
        }
        this.product_9.payment_x = this.items[8].payment_x;
        this.product_9.code = this.items[8].code;
        this.product_9.feature = this.items[8].features;

        this.product_9.without_entrance = this.items[8].without_entrance;
        this.product_9.without_interest = this.items[8].without_interest;
        this.product_9.in_carne = this.items[8].in_carne;
        this.product_9.in_card = this.items[8].in_card;

        this.product_9.options_buy = '';
        if (this.product_9.without_entrance && this.product_9.without_interest) {
            this.product_9.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_9.without_entrance)
                this.product_9.options_buy = "Sem Entrada";
            else if (this.product_9.without_interest)
                this.product_9.options_buy = "Sem Juros";
        }

        if (this.product_9.without_entrance || this.product_9.without_interest) {
            if (this.product_9.in_carne || this.product_9.in_card)
                this.product_9.options_buy += " | ";
        }

        if (this.product_9.in_carne && this.product_9.in_card) {
            this.product_9.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_9.in_carne)
                this.product_9.options_buy += "Carnê";
            else if (this.product_9.in_card)
                this.product_9.options_buy += "Cartão";
        }

        this.product_9.options_buy = this.product_9.options_buy.split("|");
        if (this.product_9.options_buy.length > 1) {
            this.product_9.options_buy = this.product_9.options_buy.join("<br>");
        } else {
            this.product_9.options_buy = this.product_9.options_buy[0];
        }
    },
    mounted() {
        if (SYSTEM_ENV === 1) {
            let interval = setInterval(() => {
                if (this.allLoaded === 10) {
                    clearInterval(interval);

                    window.scrollTo(0,0);

                    let self = this;

                    html2canvas(document.body, {
                        width: 1758,
                        allowTaint: true,
                        taintTest: false,
                    }).then(canvas => {
                        self.showHTML = false;

                        this.removeClass(document.body, "body");
                        this.removeClass(document.body, "tema-2");
                        this.removeClass(document.body, "tema-3");
                        this.removeClass(document.body, "tema-4");
                        this.removeClass(document.body, "tema-5");
                        this.removeClass(document.querySelector("html"), "html");

                        var img = canvas.toDataURL();

                        const token = localStorage.getItem("user-token");
                        this.$http.post(BASE_URL_API + '/save-image', { token, image: img }).then(response => {
                            response.json().then(json => {
                                // window.open(json.url);
                                this.url = json.url;
                            });
                        }, response => {
                            // error callback
                            alert('Ocorreu ao tentar salvar a imagem. Entre em contato com o suporte.')
                        });
                        // console.log(img);
                        // var download = document.querySelector("#download");
                        // download.src = img;
                        // download.style.display = "block";

                        // document.querySelector("#contain-all").style.display = "none";
                        this.removeClass(document.body, "body");
                        this.removeClass(document.querySelector("html"), "html");

                        // self.output = img;
                        self.$forceUpdate();
                    });
                }
            }, 1000);
        }
    },
    destroyed() {
        this.removeClass(document.body, "body");
        this.removeClass(document.querySelector("html"), "html");
    },
    methods: {
        removeClass(el, className) {
            if (el.classList)
            el.classList.remove(className);
            else
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        incrementLoad() {
            this.allLoaded++;
        },
        pad_with_zeroes(number, length) {
            var my_string = '' + number;
            while (my_string.length < length) {
                my_string = my_string + '0';
            }

            return my_string;
        },
        mounta_juridico() {
            let valid = `Oferta válida de ${this.formatDate(this.dtinicio)} até ${this.formatDate(this.dtfim)} ou enquanto durar o estoque.`
            let to = "Para";
            let c = 0;
            this.abrangencia.forEach((el, ind) => {
                to += ((c === 0) ? " " : ", ") + el.nome;
                c++;
            });
            to += ".";
            let complement = "Crédito sujeito a aprovação.";
            return valid + " " + to + " " + complement;
        },
        formatDate(dt){
            var _str = dt;
            var _new = _str.split('-').reverse().join('/');
            return _new;
        }
    }
}
</script>

<style lang="scss">
    * {
        -webkit-print-color-adjust: exact !important;   /* Chrome, Safari */
        color-adjust: exact !important;                 /*Firefox*/
    }

    @font-face {
        font-family: 'Segoe UI';
        font-style: normal;
        font-weight: normal;
        src: local('Segoe UI'), url('../../assets/segoeui.woff') format('woff');
    }

    @font-face {
        font-family: 'Segoe UI Bold';
        font-style: normal;
        font-weight: bold;
        src: url('../../assets/Segoe UI Bold.woff') format('woff');
    }


    * {
        font-family: Segoe UI;
    }

    @font-face {
        font-family: 'Helvetica Neue LT';
        font-weight: 500;
        src: url('../../assets/HelveticaNeueLTStd-BlkCnO.otf') format('opentype');
    }

    h3#chamada {
        text-align: left;
        position: absolute;
        top: 200px;
        left: 60px;
        font-size: 62px;
        font-family: 'Helvetica Neue LT';
        font-weight: 500;
        color: #EE0000;
    }

    .html {
        width: 1770px;
        height: 2560px;
        padding: 0;
        margin: 0;
    }

    .body {
        background-image: url('../../assets/base_circular_vqt.png');
        background-size: cover;
        background-repeat: no-repeat;
        width: 1758px;
        height: 2560px;
        /*border: 1px solid red;*/
        padding: 0;
        margin: 0;
    }

    #banner {
        width: 1770px;
        position: absolute;
        top: 2344px;
    }

    .tema-2 {
        background-image: url('../../assets/base_circular_dia.png') !important;
    }

    .tema-3 {
        background-image: url('../../assets/base_circular_niver.png') !important;
    }

    .tema-4 {
        background-image: url('../../assets/base_outlet.png') !important;
    }

    .tema-5 {
        background-image: url('../../assets/base_circular_maes.png') !important;
    }

    .tema-6 {
        background-image: url('../../assets/base_feirao.png') !important;
    }

    .chamada-tema-2 {
        top: 280px !important;
        left: 90px !important;
    }

    .chamada-tema-3 {
        top: 330px !important;
        left: 60px !important;
    }

    .tema-2 div[id^="container-price-"] p[id^="price-parcela-"] {
        color: #2c46f6 !important;
    }

    .tema-2 div[id^="container-price-"] p[id^="price-parcela-"] small {
        color: #2c46f6 !important;
    }

    .tema-2 div[id^="container-price-"] p[id^="prefix-"] {
        color: #2c46f6 !important;
    }

    .tema-3 div[id^="container-price-"] p[id^="price-parcela-"] {
        color: #2c46f6 !important;
    }

    .tema-3 div[id^="container-price-"] p[id^="price-parcela-"] small {
        color: #2c46f6 !important;
    }

    .tema-3 div[id^="container-price-"] p[id^="prefix-"] {
        color: #2c46f6 !important;
    }

    p#options-buy-1 {
        position: absolute;
        top: 885px;
        left: 1120px;
        text-align: left;
    }
    p#options-buy-2 {
        position: absolute;
        top: 1785px;
        left: 265px;
        text-align: left;
    }

    p.reset {
        margin: 0;
        padding: 0;
    }
    #container-price-theme-23-1 {
        width: 380px;
        height: 300px;
        position: absolute;
        top: 935px;
        left: 135px;
    }

    #container-price-theme-23-2 {
        width: 380px;
        height: 300px;
        position: absolute;
        top: 935px;
        left: 725px;
    }

    #container-price-theme-23-3 {
        width: 380px;
        height: 300px;
        position: absolute;
        top: 935px;
        left: 1315px;
    }

    #container-price-theme-23-4 {
        width: 380px;
        height: 300px;
        position: absolute;
        top: 1560px;
        left: 135px;
        // left: 725px;
    }

    #container-price-theme-23-5 {
        width: 380px;
        height: 300px;
        position: absolute;
        top: 1560px;
        // left: 1335px;
        left: 725px;
    }

    #container-price-theme-23-6 {
        width: 380px;
        height: 300px;
        position: absolute;
        top: 1560px;
        left: 1315px;
        // left: 135px;
    }

    #container-price-theme-23-7 {
        width: 380px;
        height: 300px;
        position: absolute;
        top: 2160px;
        left: 135px;
    }

    #container-price-theme-23-8 {
        width: 380px;
        height: 300px;
        position: absolute;
        top: 2160px;
        left: 725px;
    }

    #container-price-theme-23-9 {
        width: 380px;
        height: 300px;
        position: absolute;
        top: 2160px;
        left: 1315px;
    }

    .img_2_tema_23 {
        width: 480px !important;
        height: 330px !important;
        top: 510px !important;
    }

    .img_3_tema_23 {
        width: 480px !important;
        height: 330px !important;
        top: 510px !important;
    }

    img {
        // width: auto;
        // height: 100%;
        /*position: relative;
        left: 50%;
        transform: translateX(-50%);*/
    }

    /* img 1 */

    #img1-container {
        position: absolute;
        top: 510px;
        left: 70px;
        width: 480px;
        height: 330px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        /* border: 1px solid; */
    }

    // #img1-container img {
    //     width: auto;
    //     height: 100%;
    // }

    #titulo-1 {
        color: #151515;
        position: absolute;
        top: 815px;
        left: 95px;
        font-size: 28px;
        text-transform: uppercase;
        font-weight: 900;
        text-align: center;
        width: 430px;
        height: 130px;
        overflow: hidden;
    }

    #carac-1 {
        color: #151515;
        position: absolute;
        top: 1595px;
        left: 200px;
        font-size: 20px;
        text-align: right;
        width: 412px;
        height: 166px;
        overflow: hidden;
        display: none;
    }

    #container-price-1 {
        border: 4px solid #151515;
        border-radius: 55px;
        width: 290px;
        position: absolute;
        top: 935px;
        left: 155px;
        padding: 10px 0px;
    }

    #container-price-1 #values-1 {
        color: #151515;
        font-size: 28px;
        margin: 0;
        margin-left: 30px;
    }

    #container-price-1 #preco-prazo-1 {
        font-size: 24px;
        margin: 0;
        margin-left: 12px;
    }

    #container-price-1 #price-parcela-1 {
        font-size: 66px;
        margin: 0;
        color: #fa7b19;
        line-height: 1;
        margin-left: 40px;
        font-weight: 900;
    }

    #container-price-1 #price-parcela-1 small {
        font-size: 30px;
        margin: 0;
        color: #fa7b19;
        position: absolute;
        top: 56px;
        font-weight: 900;
    }

    #container-price-1 #parcelas-1 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 38px;
        margin-top: 10px;
    }

    #container-price-1 #prefix-1 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 42px;
        margin-top: 10px;
        color: #fa7b19;
    }


    /* img 2 */

    #img2-container {
        position: absolute;
        top: 610px;
        left: 660px;
        width: 480px;
        height: 230px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        /* border: 1px solid; */
    }

    // #img2-container img {
    //     width: auto;
    //     height: 100%;
    // }

    #titulo-2 {
        color: #151515;
        position: absolute;
        top: 825px;
        left: 690px;
        font-size: 28px;
        text-transform: uppercase;
        font-weight: 900;
        text-align: center;
        width: 430px;
        height: 130px;
        overflow: hidden;
    }

    #carac-2 {
        color: #151515;
        position: absolute;
        top: 1605px;
        left: 835px;
        font-size: 20px;
        text-align: right;
        width: 392px;
        height: 166px;
        overflow: hidden;
        display: none;
    }

    #container-price-2 {
        border: 4px solid #151515;
        border-radius: 55px;
        width: 290px;
        position: absolute;
        top: 935px;
        left: 750px;
        padding: 10px 0px;
    }

    #container-price-2 #values-2 {
        color: #151515;
        font-size: 28px;
        margin: 0;
        margin-left: 30px;
    }

    #container-price-2 #preco-prazo-2 {
        font-size: 22px;
        margin: 0;
        margin-left: 24px;
    }

    #container-price-2 #price-parcela-2 {
        font-size: 66px;
        margin: 0;
        color: #fa7b19;
        line-height: 1;
        margin-left: 40px;
        font-weight: 900;
    }

    #container-price-2 #price-parcela-2 small {
        font-size: 30px;
        margin: 0;
        color: #fa7b19;
        position: absolute;
        top: 56px;
        font-weight: 900;
    }

    #container-price-2 #parcelas-2 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 38px;
        margin-top: 10px;
    }

    #container-price-2 #prefix-2 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 44px;
        margin-top: 10px;
        color: #fa7b19;
    }

    /* img 3 */

    #img3-container {
        position: absolute;
        top: 560px;
        left: 1250px;
        width: 480px;
        height: 280px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        /* border: 1px solid; */
    }

    // #img3-container img {
    //     width: auto;
    //     height: 100%;
    // }

    #titulo-3 {
        color: #151515;
        position: absolute;
        top: 825px;
        left: 1285px;
        font-size: 28px;
        text-transform: uppercase;
        font-weight: 900;
        text-align: center;
        width: 430px;
        height: 130px;
        overflow: hidden;
    }

    #carac-3 {
        color: #151515;
        position: absolute;
        top: 1605px;
        left: 835px;
        font-size: 20px;
        text-align: right;
        width: 392px;
        height: 166px;
        overflow: hidden;
        display: none;
    }

    #container-price-3 {
        border: 4px solid #151515;
        border-radius: 55px;
        width: 310px;
        position: absolute;
        top: 935px;
        left: 1340px;
        padding: 10px 0px;
    }

    #container-price-3 #values-3 {
        color: #151515;
        font-size: 28px;
        margin: 0;
        margin-left: 30px;
    }

    #container-price-3 #preco-prazo-3 {
        font-size: 22px;
        margin: 0;
        margin-left: 24px;
    }

    #container-price-3 #price-parcela-3 {
        font-size: 66px;
        margin: 0;
        color: #fa7b19;
        line-height: 1;
        margin-left: 40px;
        font-weight: 900;
    }

    #container-price-3 #price-parcela-3 small {
        font-size: 30px;
        margin: 0;
        color: #fa7b19;
        position: absolute;
        top: 56px;
        font-weight: 900;
    }

    #container-price-3 #parcelas-3 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 38px;
        margin-top: 10px;
    }

    #container-price-3 #prefix-3 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 44px;
        margin-top: 10px;
        color: #fa7b19;
    }

    /* img 4 */

    #img4-container {
        position: absolute;
        top: 1140px;
        left: 70px;
        width: 480px;
        height: 330px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        /* border: 1px solid; */
    }

    // #img4-container img {
    //     width: auto;
    //     height: 100%;
    // }

    #titulo-4 {
        color: #151515;
        position: absolute;
        top: 1445px;
        left: 95px;
        font-size: 28px;
        text-transform: uppercase;
        font-weight: 900;
        text-align: center;
        width: 430px;
        height: 130px;
        overflow: hidden;
    }

    #carac-4 {
        color: #151515;
        position: absolute;
        top: 1595px;
        left: 200px;
        font-size: 20px;
        text-align: right;
        width: 412px;
        height: 166px;
        overflow: hidden;
        display: none;
    }

    #container-price-4 {
        border: 4px solid #151515;
        border-radius: 55px;
        width: 310px;
        position: absolute;
        top: 1555px;
        left: 145px;
        padding: 10px 0px;
    }

    #container-price-4 #values-4 {
        color: #151515;
        font-size: 28px;
        margin: 0;
        margin-left: 30px;
    }

    #container-price-4 #preco-prazo-4 {
        font-size: 22px;
        margin: 0;
        margin-left: 24px;
    }

    #container-price-4 #price-parcela-4 {
        font-size: 66px;
        margin: 0;
        color: #fa7b19;
        line-height: 1;
        margin-left: 40px;
        font-weight: 900;
    }

    #container-price-4 #price-parcela-4 small {
        font-size: 30px;
        margin: 0;
        color: #fa7b19;
        position: absolute;
        top: 56px;
        font-weight: 900;
    }

    #container-price-4 #parcelas-4 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 38px;
        margin-top: 10px;
    }

    #container-price-4 #prefix-4 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 42px;
        margin-top: 10px;
        color: #fa7b19;
    }


    /* img 5 */

    #img5-container {
        position: absolute;
        top: 1140px;
        left: 660px;
        width: 480px;
        height: 330px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        /* border: 1px solid; */
    }

    // #img5-container img {
    //     width: auto;
    //     height: 100%;
    // }

    #titulo-5 {
        color: #151515;
        position: absolute;
        top: 1445px;
        left: 690px;
        font-size: 28px;
        text-transform: uppercase;
        font-weight: 900;
        text-align: center;
        width: 430px;
        height: 130px;
        overflow: hidden;
    }

    #carac-5 {
        color: #151515;
        position: absolute;
        top: 1605px;
        left: 835px;
        font-size: 20px;
        text-align: right;
        width: 392px;
        height: 166px;
        overflow: hidden;
        display: none;
    }

    #container-price-5 {
        border: 4px solid #151515;
        border-radius: 55px;
        width: 290px;
        position: absolute;
        top: 1555px;
        left: 750px;
        padding: 10px 0px;
    }

    #container-price-5 #values-5 {
        color: #151515;
        font-size: 28px;
        margin: 0;
        margin-left: 30px;
    }

    #container-price-5 #preco-prazo-5 {
        font-size: 22px;
        margin: 0;
        margin-left: 24px;
    }

    #container-price-5 #price-parcela-5 {
        font-size: 66px;
        margin: 0;
        color: #fa7b19;
        line-height: 1;
        margin-left: 40px;
        font-weight: 900;
    }

    #container-price-5 #price-parcela-5 small {
        font-size: 30px;
        margin: 0;
        color: #fa7b19;
        position: absolute;
        top: 56px;
        font-weight: 900;
    }

    #container-price-5 #parcelas-5 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 38px;
        margin-top: 10px;
    }

    #container-price-5 #prefix-5 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 44px;
        margin-top: 10px;
        color: #fa7b19;
    }

    /* img 6 */

    #img6-container {
        position: absolute;
        top: 1140px;
        left: 1250px;
        width: 480px;
        height: 330px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        /* border: 1px solid; */
    }

    // #img6-container img {
    //     width: auto;
    //     height: 100%;
    // }

    #titulo-6 {
        color: #151515;
        position: absolute;
        top: 1445px;
        left: 1285px;
        font-size: 28px;
        text-transform: uppercase;
        font-weight: 900;
        text-align: center;
        width: 430px;
        height: 130px;
        overflow: hidden;
    }

    #carac-6 {
        color: #151515;
        position: absolute;
        top: 1605px;
        left: 835px;
        font-size: 20px;
        text-align: right;
        width: 392px;
        height: 166px;
        overflow: hidden;
        display: none;
    }

    #container-price-6 {
        border: 4px solid #151515;
        border-radius: 55px;
        width: 310px;
        position: absolute;
        top: 1555px;
        left: 1340px;
        padding: 10px 0px;
    }

    #container-price-6 #values-6 {
        color: #151515;
        font-size: 28px;
        margin: 0;
        margin-left: 30px;
    }

    #container-price-6 #preco-prazo-6 {
        font-size: 22px;
        margin: 0;
        margin-left: 24px;
    }

    #container-price-6 #price-parcela-6 {
        font-size: 66px;
        margin: 0;
        color: #fa7b19;
        line-height: 1;
        margin-left: 40px;
        font-weight: 900;
    }

    #container-price-6 #price-parcela-6 small {
        font-size: 30px;
        margin: 0;
        color: #fa7b19;
        position: absolute;
        top: 56px;
        font-weight: 900;
    }

    #container-price-6 #parcelas-6 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 38px;
        margin-top: 10px;
    }

    #container-price-6 #prefix-6 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 44px;
        margin-top: 10px;
        color: #fa7b19;
    }

    /* img 7 */

    #img7-container {
        position: absolute;
        top: 1740px;
        left: 70px;
        width: 480px;
        height: 330px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        /* border: 1px solid; */
    }

    // #img7-container img {
    //     width: auto;
    //     height: 100%;
    // }

    #titulo-7 {
        color: #151515;
        position: absolute;
        top: 2040px;
        left: 95px;
        font-size: 28px;
        text-transform: uppercase;
        font-weight: 900;
        text-align: center;
        width: 430px;
        height:90px;
        overflow: hidden;
    }

    #carac-7 {
        color: #151515;
        position: absolute;
        top: 1595px;
        left: 200px;
        font-size: 20px;
        text-align: right;
        width: 412px;
        height: 166px;
        overflow: hidden;
        display: none;
    }

    #container-price-7 {
        border: 4px solid #151515;
        border-radius: 55px;
        width: 315px;
        position: absolute;
        top: 2155px;
        left: 145px;
        padding: 10px 0px;
    }

    #container-price-7 #values-7 {
        color: #151515;
        font-size: 24px;
        margin: 0;
        margin-left: 50px;
    }

    #container-price-7 #preco-prazo-7 {
        font-size: 24px;
        margin: 0;
        margin-left: 24px;
    }

    #container-price-7 #price-parcela-7 {
        font-size: 60px;
        margin: 0;
        color: #fa7b19;
        line-height: 1;
        margin-left: 40px;
        font-weight: 900;
    }

    #container-price-7 #price-parcela-7 small {
        font-size: 30px;
        margin: 0;
        color: #fa7b19;
        position: absolute;
        top: 56px;
        font-weight: 900;
    }

    #container-price-7 #parcelas-7 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 38px;
        margin-top: 10px;
    }

    #container-price-7 #prefix-7 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 42px;
        margin-top: 10px;
        color: #fa7b19;
    }


    /* img 8 */

    #img8-container {
        position: absolute;
        top: 1740px;
        left: 660px;
        width: 480px;
        height: 330px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        /* border: 1px solid; */
    }

    // #img8-container img {
    //     width: auto;
    //     height: 100%;
    // }

    #titulo-8 {
        color: #151515;
        position: absolute;
        top: 2040px;
        left: 690px;
        font-size: 28px;
        text-transform: uppercase;
        font-weight: 900;
        text-align: center;
        width: 430px;
        height: 90px;
        overflow: hidden;
    }

    #carac-8 {
        color: #151515;
        position: absolute;
        top: 1605px;
        left: 835px;
        font-size: 20px;
        text-align: right;
        width: 392px;
        height: 166px;
        overflow: hidden;
        display: none;
    }

    #container-price-8 {
        border: 4px solid #151515;
        border-radius: 55px;
        width: 315px;
        position: absolute;
        top: 2155px;
        left: 740px;
        padding: 10px 0px;
    }

    #container-price-8 #values-8 {
        color: #151515;
        font-size: 26px;
        margin: 0;
        margin-left: 50px;
    }

    #container-price-8 #preco-prazo-8 {
        font-size: 24px;
        margin: 0;
        margin-left: 24px;
    }

    #container-price-8 #price-parcela-8 {
        font-size: 60px;
        margin: 0;
        color: #fa7b19;
        line-height: 1;
        margin-left: 40px;
        font-weight: 900;
    }

    #container-price-8 #price-parcela-8 small {
        font-size: 30px;
        margin: 0;
        color: #fa7b19;
        position: absolute;
        top: 56px;
        font-weight: 900;
    }

    #container-price-8 #parcelas-8 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 38px;
        margin-top: 10px;
    }

    #container-price-8 #prefix-8 {
        padding: 0;
        margin: 0;
        font-size: 24px;
        line-height: 1;
        margin-left: 44px;
        margin-top: 10px;
        color: #fa7b19;
    }

    /* img 9 */

    #img9-container {
        position: absolute;
        top: 1740px;
        left: 1250px;
        width: 480px;
        height: 330px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        /* border: 1px solid; */
    }

    // #img9-container img {
    //     width: auto;
    //     height: 100%;
    // }

    #titulo-9 {
        color: #151515;
        position: absolute;
        top: 2040px;
        left: 1280px;
        font-size: 28px;
        text-transform: uppercase;
        font-weight: 900;
        text-align: center;
        width: 430px;
        height: 90px;
        overflow: hidden;
    }

    #carac-9 {
        color: #151515;
        position: absolute;
        top: 1605px;
        left: 835px;
        font-size: 20px;
        text-align: right;
        width: 392px;
        height: 166px;
        overflow: hidden;
        display: none;
    }

    #container-price-9 {
        border: 4px solid #151515;
        border-radius: 55px;
        width: 315px;
        position: absolute;
        top: 2155px;
        left: 1330px;
        padding: 10px 0px;
    }

    #container-price-9 #values-9 {
        color: #151515;
        font-size: 26px;
        margin: 0;
        margin-left: 50px;
    }

    #container-price-9 #preco-prazo-9 {
        font-size: 24px;
        margin: 0;
        margin-left: 24px;
        /* position: relative; */
        /* left: 24px; */
        /* width: 360px; */
    }

    #container-price-9 #price-parcela-9 {
        font-size: 60px;
        margin: 0;
        color: #fa7b19;
        line-height: 1;
        margin-left: 40px;
        font-weight: 900;
    }

    #container-price-9 #price-parcela-9 small {
        font-size: 30px;
        margin: 0;
        color: #fa7b19;
        position: absolute;
        top: 56px;
        font-weight: 900;
    }

    #container-price-9 #parcelas-9 {
        padding: 0;
        margin: 0;
        font-size: 20px;
        line-height: 1;
        margin-left: 38px;
        margin-top: 10px;
    }

    #container-price-9 #prefix-9 {
        padding: 0;
        margin: 0;
        font-size: 20px;
        line-height: 1;
        margin-left: 44px;
        margin-top: 10px;
        color: #fa7b19;
    }

    #juridico {
        position: absolute;
        top: 2508px;
        width: 1663px;
        left: 55px;
    }

    #juridico p {
        margin: 0;
        width: 100%;
    }

    #download {
        height: 100vh;
        width: auto;
    }

    .html2canvas-container { width: 3000px !important; height: 3000px !important; }
</style>





// WEBPACK FOOTER //
// src/components/generate9x/Generate9x.vue